import Close from '../icons/Close'
import styles from './Tags.module.css'

function Tag({name, onRemoveTag, } : {name: string, onRemoveTag: (name: string) => void }) {

  return (
    <div className={styles.tag} >
      <span>{name}</span>
      <button
        onClick={() => onRemoveTag(name)}
        className={styles.removeButton}>
        <Close className={styles.closeIcon} color='#fff' />
      </button>
    </div>
  )
}

export default Tag